export default __webpack_public_path__ + "static/media/sidebar-4.67647f51.jpg";